module.exports = __webpack_public_path__ + "media/arrow.79e5ca49.svg";